import React from 'react'
import { Modal } from 'components/ui/Modal'
import { Button } from 'components/ui/Button'

export const ConfirmDialog = ({ open, onClose, title = 'Подтвердите действие', message, okText = 'ОК', cancelText = 'Отмена', onOk, loading = false }) => {
  if (!open) return null
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      footer={
        <>
          <Button variant="ghost" onClick={onClose}>{cancelText}</Button>
          <Button onClick={onOk} disabled={loading}>{loading ? 'Выполняю…' : okText}</Button>
        </>
      }
    >
      <p className="text-sm opacity-80">{message}</p>
    </Modal>
  )
}
